import { Controller } from "@hotwired/stimulus";

// Menu « Utilisateurs » : cocher des comptes pour générer leurs identifiants
// d'un coup. Tient le compte des cases cochées, la case « tout cocher », et le
// choix « les comptes cochés » / « tous les comptes des filtres » de la modale.
export default class extends Controller {
  static targets = ["selectAll", "item", "count", "selectedChoice", "filteredChoice", "submit"];

  connect() {
    this.refresh();
  }

  toggleAll() {
    this.itemTargets.forEach((box) => { box.checked = this.selectAllTarget.checked; });
    this.refresh();
  }

  refresh() {
    const checked = this.itemTargets.filter((box) => box.checked).length;
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checked > 0 && checked === this.itemTargets.length;
      this.selectAllTarget.indeterminate = checked > 0 && checked < this.itemTargets.length;
    }
    this.countTargets.forEach((node) => { node.textContent = checked; });
    // Les téléchargements « de la sélection » attendent une case cochée.
    this.submitTargets.forEach((button) => { button.disabled = checked === 0; });
    if (!this.hasSelectedChoiceTarget) return;

    // Rien de coché : seuls « tous les comptes des filtres » restent possibles.
    this.selectedChoiceTarget.disabled = checked === 0;
    if (checked === 0) this.filteredChoiceTarget.checked = true;
    else if (!this.filteredChoiceTarget.dataset.picked) this.selectedChoiceTarget.checked = true;
  }

  // L'utilisateur a choisi lui-même « tous les comptes des filtres ».
  pick(event) {
    this.filteredChoiceTarget.dataset.picked = event.target === this.filteredChoiceTarget ? "1" : "";
  }
}
